export const stats = [
  { value: '+430', label: "Unità e Fichè Pronte all'Uso" },
  { value: '+1.200', label: 'Coach e Istruttori Soddisfatti' },
  { value: '4.000+', label: 'Ore di Pianificazione Risparmiate' },
  { value: '98%', label: 'Lo Raccomandano' },
]

export const differenceStats = [
  { value: '+430', label: 'Unità e Attività (Livello Base a Mental Coaching)' },
  { value: '6', label: 'Volumi Digitali Completi (PDF Premium)' },
  { value: '100%', label: 'Download Immediato' },
]

export const beforeItems = [
  'Ore passate a cercare tabelle e dati tecnici su 10 siti diversi',
  'Sessioni confuse perché mancano supporti visivi chiari per spiegare la tecnica o il core',
  "Nessuna connessione reale tra la teoria e l'azione in pista o su strada",
  'Difficoltà nel creare programmi personalizzati senza lavorare di notte',
  'Atleti demotivati che sentono la mancanza di una struttura professionale',
]

export const afterItems = [
  '5 minuti di revisione e sei pronto per scendere in campo con sicurezza',
  "Schede visuali e moderne che catturano l'attenzione al primo sguardo",
  'Infografiche e schemi tecnici integrati in ogni singola unità',
  'Test, valutazioni e rubriche già pronti al 100%',
  'Atleti motivati che capiscono il movimento e si sentono guidati da un esperto',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Ansia da spiegazione: arrivare in classe/campo senza sapere come rendere semplice un concetto complesso (VAM, soglia o biomeccanica)',
  },
  {
    emoji: '⏱️',
    text: "Domeniche rubate: passare l'intera domenica a preparare materiali che dovrebbero essere già pronti",
  },
  {
    emoji: '🤷',
    text: 'Caos creativo: faticare a trovare schede didattiche che siano davvero di alta qualità, visive e aggiornate',
  },
  {
    emoji: '📋',
    text: "Valutazione infinita: nessuna rubrica di valutazione chiara o test allineato con il programma dell'atleta",
  },
  {
    emoji: '😴',
    text: 'Atleti persi: allievi che restano indietro perché il materiale non è inclusivo o è troppo testuale',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Volumi PDF Professionali',
    text: "Un curriculum completo basato sull'anno sportivo (Livello Base – Mental Coaching)",
  },
  {
    emoji: '🏃',
    title: 'Kit di Tecnica ed Esercitazioni Visive',
    text: 'Schede illustrate ad alta risoluzione pronte da stampare o proiettare',
  },
  {
    emoji: '✏️',
    title: 'Script delle Lezioni «Pronti al Volo»',
    text: 'Suggerimenti didattici che ti dicono esattamente come condurre la sessione',
  },
  {
    emoji: '📐',
    title: 'Running Visuale: Infografiche e Schemi',
    text: 'Grafiche moderne che rendono comprensibili i processi fisiologici e meccanici',
  },
  {
    emoji: '📊',
    title: 'Test, Valutazioni e Progressi',
    text: 'Strumenti completi per monitorare la condizione fisica costantemente',
  },
  {
    emoji: '🔑',
    title: 'Answer Keys (Tabelle di Riferimento)',
    text: 'Soluzioni di ritmi e checklist per correzioni istantanee e senza stress',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/sYkJsdVzXJk6d7iR8mVc9g/Captura-de-pantalla-2026-09-14-a-las-4.06.23_p._m..webp',
    level: 'Vol. 5 · Mobilità e Recupero',
    title: 'Unità 3: Preparare il Corpo — Riscaldamento e Mobilità',
    caption:
      'Routine pre-corsa di 5-10 minuti già sequenziata: sette esercizi numerati con foto di esecuzione, ripetizioni, durata e livello di intensità.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3KA1CLJdjA652jeiD1A9xs/Captura-de-pantalla-2026-09-14-a-las-4.09.43_p._m..webp',
    level: 'Vol. 2 · Velocità e Intervalli',
    title: 'Settimana 2: Intensità Aumenta',
    caption:
      'Micro-ciclo settimanale pronto da consegnare: sedute giorno per giorno con percentuali di VAM, recuperi e confronto diretto con la settimana precedente.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/33Jwx5JVnC2yXni79YcHBd/Captura-de-pantalla-2026-09-14-a-las-4.11.41_p._m..webp',
    level: 'Vol. 3 · Endurance e Lunghi',
    title: 'La Fisiologia della Soglia Anaerobica',
    caption:
      'Infografica che spiega le quattro zone di FCM con il grafico di produzione ed eliminazione del lattato: la teoria diventa immediata da capire.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/k48KkkfdyqiPVMRHe2YKw2/Captura-de-pantalla-2026-09-14-a-las-4.13.02_p._m..webp',
    level: 'Vol. 4 · Forza e Prevenzione',
    title: 'Esercizio 1 — Plancia (Plank)',
    caption:
      'Scheda tecnica completa: muscoli coinvolti, allineamento illustrato, progressione dalla settimana 1 alla 8, recupero e frequenza settimanale.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dpQ19fB9LqeD3bnULcWmKL/Captura-de-pantalla-2026-09-14-a-las-4.14.43_p._m..webp',
    level: 'Vol. 5 · Mobilità e Recupero',
    title: 'Esercizio 1: Quad Stretch — Allungamento Quadricipite',
    caption:
      'Sequenza in tre passaggi con gli errori comuni evidenziati e una tabella di riferimento su durata, intensità, respirazione e progressione.',
  },
]

export const bonuses = [
  {
    title: "La Guida all'Equipaggiamento Perfetto",
    was: '€17',
    text: 'La guida definitiva per non sbagliare acquisto. Come scegliere la scarpa corretta, tessuti tecnici e i top 10 gadget',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/8968edc8-9859-4253-8fdc-de3d44ecee9b.jpg',
  },
  {
    title: 'Ricette e Piano Alimentare per Runner',
    was: '€17',
    text: '«Gusto & Corsa»: 50 ricette veloci, piani settimanali e lista dei 20 superfood essenziali per il recupero',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/73e12473-907b-4400-9b94-9a3ae6af54c6.jpg',
  },
  {
    title: 'Diario di Bordo & Tracker dei Progressi',
    was: '€17',
    text: '«Il mio diario di corsa»: tracker di 365 giorni per registrare km, tempi, battiti e sensazioni',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a7b5d542-3e2b-475e-a687-1c85fa66b905.jpg',
  },
  {
    title: 'Video-Lezioni Mastery (Slides per il docente)',
    was: '€17',
    text: '«Running Academy»: slide pronte con infografiche professionali su biomeccanica e fisiologia da proiettare',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a7f9d356-8a5f-4c87-971f-4f569c2e950f.jpg',
  },
  {
    title: 'Podcast Coaching (Script da leggere)',
    was: '€17',
    text: '«Coach in spalla»: 10 script motivazionali pronti per guidare i tuoi atleti nei momenti di crisi',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0c50c567-7963-43a8-94fd-18678250c819.jpg',
  },
]

export const offerRows = [
  { label: 'RUNNING PRONTO™ (6 Volumi Digitali PDF)', value: '€102' },
  { label: '5 Bonus Strategici Esclusivi', value: '€85' },
]

export const testimonials = [
  {
    quote:
      'Finalmente schede tecniche chiare e allenamenti che i ragazzi seguono con interesse. Ho recuperato i miei weekend!',
    name: 'Chiara M.',
    location: 'Milano 🇮🇹',
  },
  {
    quote:
      "Il Diario di Bordo ha cambiato l'atteggiamento della mia squadra. Sono tutti motivatissimi e i risultati si vedono.",
    name: 'Elena V.',
    location: 'Torino 🇮🇹',
  },
]

export const faqs = [
  {
    q: "Come ricevo il materiale dopo l'acquisto?",
    a: "Il sistema è a download istantaneo. Non appena completi il pagamento, riceverai immediatamente un'email con i link diretti per scaricare i 6 volumi e i 5 bonus in formato PDF. Potrai salvarli sul tuo computer, tablet o smartphone e accedervi per sempre.",
  },
  {
    q: 'È un abbonamento mensile o un pagamento unico?',
    a: 'È un pagamento unico. Non ci sono costi nascosti né abbonamenti ricorrenti. Paghi oggi 19€ e il pacchetto RUNNING PRONTO™ sarà tuo per tutta la vita, inclusi tutti i futuri aggiornamenti gratuiti del sistema.',
  },
  {
    q: 'Per quali livelli di atleti è adatto RUNNING PRONTO™?',
    a: 'Il sistema è progettato per coprire ogni livello. Dal Volume 1 (principianti e tecnica di base) fino al Volume 6 (mental coaching avanzato e strategia di gara). È perfetto sia per chi allena gruppi amatoriali, sia per chi segue atleti agonisti che puntano alla performance.',
  },
  {
    q: 'Posso stampare le schede e gli esercizi?',
    a: 'Assolutamente sì! Tutto il materiale è in formato PDF premium ad alta risoluzione, ottimizzato per la stampa in A4. Le schede tecniche, le flashcard, i planner e i diari di bordo sono stati creati appositamente per essere stampati e portati direttamente in pista o sul campo.',
  },
  {
    q: "Il materiale è adatto anche per l'insegnamento scolastico?",
    a: 'Certamente. Molti dei nostri utenti sono insegnanti di educazione fisica che utilizzano i volumi di Tecnica, Forza e Mobilità per strutturare lezioni di atletica in modo molto più visuale, moderno e coinvolgente per gli studenti.',
  },
  {
    q: 'Cosa succede se il materiale non mi convince?',
    a: 'Sei protetto dalla nostra Garanzia «Soddisfatti o Rimborsati» di 7 Giorni. Se per qualsiasi motivo senti che il sistema non ti fa risparmiare tempo o non migliora la qualità dei tuoi allenamenti, mandaci un\u2019email e ti rimborseremo l\u2019intero importo. Nessuna domanda, nessun rischio.',
  },
  {
    q: 'Posso visualizzare i PDF sul tablet o smartphone durante l\u2019allenamento?',
    a: 'Sì, i PDF sono ottimizzati per la visualizzazione digitale. Molti coach utilizzano il tablet direttamente sul campo per mostrare le infografiche e le illustrazioni degli esercizi agli atleti in tempo reale, migliorando la comprensione del movimento.',
  },
  {
    q: 'È sicuro il pagamento sul vostro sito?',
    a: 'Sì, al 100%. Utilizziamo protocolli di sicurezza SSL a 256 bit, lo standard bancario più elevato, per proteggere i tuoi dati. Puoi completare l\u2019acquisto in totale sicurezza utilizzando la tua Carta di Credito o di Debito.',
  },
]
